<template>
  <nav-bar title="订单详细" />
  <Content :bottom="showSubmit? 76 : 0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <customer-info />
    <van-cell-group class="group" :title="orderBase.placeDate" >
      <van-cell v-for="item in infoList" :key="item.id" :title="item.goodsName" :value="`${item.goodsCount}瓶`" />
    </van-cell-group>
  </Content>
  <div v-if="showSubmit" class="btn-conatiner van-hairline--top">
    <van-button block type="primary" native-type="button" :loading="loading" :disabled="loading" @click="onSubmit">
      收货确认
    </van-button>
  </div>
</template>
<script>
import { getOrderInfo, userReceiveGoods } from '@/api/order'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useSubmit } from '@/hooks/useSubmit'
import { reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  name: 'OrderInfo', // 订单详细
  props: ['orderId'],
  setup (props) {
    // 获取详细
    const detail = reactive({
      infoList: [],
      orderBase: {}
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getOrderInfo, (data) => {
      for (const key in detail) {
        detail[key] = data[key]
      }
    }, props.orderId)
    getDataLoading()

    // 收货确认
    const router = useRouter()
    const store = useStore()
    const userId = computed(() => store.state.customer.userId)
    const params = {
      orderId: props.orderId,
      userId: userId.value
    }
    const { onSubmit, loading } = useSubmit(userReceiveGoods, params, () => {
      router.back()
    })
    const showSubmit = computed(() => (!showLoading.value && detail.orderBase.orderStatus === '02'))
    return {
      getDataLoading,
      showLoading,
      isLoading,
      ...toRefs(detail),
      onSubmit,
      loading,
      showSubmit
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
